import { useState } from 'react'
import { FaAngleLeft } from 'react-icons/fa6'
import { apis } from '../../api/apiUrl'

const LecturerDetail = ({ lecturer, details, loading, error, onBack }) => {
  const [activeTab, setActiveTab] = useState('about')

  const tabs = [
    { id: 'about', label: 'About Me' },
    { id: 'courses', label: 'Courses Taught' },
    { id: 'professional', label: 'Professional Bodies' },
    { id: 'research', label: 'Research Projects' },
    { id: 'publications', label: 'Publications' }
  ]

  if (loading) {
    return (
      <div className='flex flex-col gap-5 min-w-[60vw] max-w-full w-full'>
        <div className='w-full flex items-center justify-center gap-3 p-8'>
          <div className='w-5 h-5 border-2 border-t-[4px] border-t-[#3d4a6c] rounded-full animate-spin'></div>
          <span className='text-[#3d4a6c] font-bold'>
            Loading lecturer details...
          </span>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className='flex flex-col gap-5 min-w-[60vw] max-w-full w-full'>
        <button
          onClick={onBack}
          className='flex items-center gap-2 p-4 text-[#3d4a6c] hover:bg-gray-100 rounded-lg transition-colors w-fit'
        >
          <FaAngleLeft />
          <span>Back to List</span>
        </button>
        <div className='w-full flex items-center justify-center gap-3 p-8'>
          <span className='text-red-500 font-bold'>{error}</span>
        </div>
      </div>
    )
  }

  if (!details) return null

  return (
    <div className='flex flex-col gap-5 min-w-[60vw] max-w-full w-full p-4 lg:p-8'>
      {/* Back Button */}
      <button
        onClick={onBack}
        className='flex items-center gap-2 p-4 text-[#3d4a6c] hover:bg-gray-100 rounded-lg transition-colors w-fit'
      >
        <FaAngleLeft />
        <span>Back to List</span>
      </button>

      {/* Profile Header */}
      <div className='flex flex-col items-center gap-6  bg-white'>
        <div className='w-48 h-64 rounded-lg overflow-hidden shadow-lg'>
          <img
            src={`${apis.domain}${details?.imageUrl }`}
            alt={details?.fullName}
            className='w-full h-full object-cover' 
            onError={(e) => { e.target.onerror = null; e.target.src = apis.base_url+'media/czebqq0k/empty-avatar.jpg'; }}

          />
        </div>
        <h1 className='text-2xl font-bold text-gray-800 text-center'>
          {details?.fullName}
        </h1>
      </div>

      {/* Tabs */}
      <div className='bg-white border border-gray-200 rounded-lg w-full max-w-5xl mx-auto'>
        <div className='flex border-b border-gray-200 w-full overflow-y-auto'>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-3 flex-1 text-sm whitespace-nowrap font-medium border-r border-gray-200 last:border-r-0 transition-colors ${
                activeTab === tab.id
                  ? 'bg-[#3d4a6c] text-white'
                  : 'bg-gray-200 text-[#071946B2] hover:bg-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className='p-6'>
          {activeTab === 'about' && (
            <div className='space-y-6'>
              <h2 className='text-xl font-bold text-gray-800'>About Me</h2>

              <div className='grid grid-cols-1 md:grid-cols-2 gap-2 max-w-xs text-sm'>
                <span className='font-semibold text-gray-600'>Full Name:</span>
                <p className='text-[#071946B2]'>{details?.fullName}</p>

                <span className='font-semibold text-gray-600'>Email:</span>
                <p className='text-[#071946B2]'>{details.email}</p>

                <span className='font-semibold text-gray-600'>
                  Contact Number:
                </span>
                <p className='text-[#071946B2]'>
                  {details.phone}{' '}
                  {details.phoneExtension && `Ext.${details.phoneExtension}`}
                </p>

                <span className='font-semibold text-gray-600'>Department:</span>
                <p className='text-[#071946B2]'>{details.department}</p>
              </div>

              <div>
                <h3 className='text-lg font-bold text-gray-800 mb-3'>
                  Academic Qualifications
                </h3>
                <ul className='list-disc list-inside space-y-1 text-sm text-[#071946B2]'>
                  {details.academicQualifications?.map(
                    (qualification, index) => (
                      <li key={index}>{qualification}</li>
                    )
                  )}
                </ul>
              </div>

              {details.workExperience && details.workExperience.length > 0 && (
                <div>
                  <div className='overflow-x-auto'>
                    <table className='w-full border border-gray-300'>
                      <thead className='!bg-[#E5EBFA] font-bold'>
                        <tr>
                          <th className='border border-gray-300 px-4 py-2 text-left text-sm'>
                            Position
                          </th>
                          <th className='border border-gray-300 px-4 py-2 text-left text-sm'>
                            Place of Work
                          </th>
                          <th className='border border-gray-300 px-4 py-2 text-left text-sm'>
                            Start
                          </th>
                          <th className='border border-gray-300 px-4 py-2 text-left text-sm'>
                            End
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {details.workExperience.map((work, index) => (
                          <tr key={index} className='even:bg-gray-50'>
                            <td className='border border-gray-300 px-4 py-2 text-sm'>
                              {work.position}
                            </td>
                            <td className='border border-gray-300 px-4 py-2 text-sm'>
                              {work.companyName}
                            </td>
                            <td className='border border-gray-300 px-4 py-2 text-sm'>
                              {work.startYear}
                            </td>
                            <td className='border border-gray-300 px-4 py-2 text-sm'>
                              {work.endYear || 'Present'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'courses' && (
            <div className='space-y-4'>
              <h2 className='text-xl font-bold text-gray-800'>
                Courses Taught
              </h2>
              {details.courses && details.courses.length > 0 ? (
                <ul className='list-disc list-inside space-y-2 text-sm text-[#071946B2]'>
                  {details.courses.map((course, index) => (
                    <li key={index}>
                      <span className='font-medium'>{course.courseCode}</span> -{' '}
                      {course.courseName}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-500'>
                  No courses information available.
                </p>
              )}
            </div>
          )}

          {activeTab === 'professional' && (
            <div className='space-y-4'>
              <h2 className='text-xl font-bold text-gray-800'>
                Professional Bodies
              </h2>
              {details.professionalBodies &&
              details.professionalBodies.length > 0 ? (
                <ul className='list-disc list-inside space-y-2 text-sm text-[#071946B2]'>
                  {details.professionalBodies.map((body, index) => (
                    <li key={index}>{body}</li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-500'>
                  No professional bodies information available.
                </p>
              )}
            </div>
          )}

          {activeTab === 'research' && (
            <div className='space-y-4'>
              <h2 className='text-xl font-bold text-gray-800'>
                Research Projects
              </h2>
              {details.researchProjects &&
              details.researchProjects.length > 0 ? (
                <ul className='list-disc list-inside space-y-2 text-sm text-[#071946B2]'>
                  {details.researchProjects.map((project, index) => (
                    <li key={index}>{project}</li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-500'>
                  No research projects information available.
                </p>
              )}
            </div>
          )}

          {activeTab === 'publications' && (
            <div className='space-y-4'>
              <h2 className='text-xl font-bold text-gray-800'>Publications</h2>
              {details.publications && details.publications.length > 0 ? (
                <ul className='list-disc list-inside space-y-3 text-sm text-[#071946B2]'>
                  {details.publications.map((publication, index) => (
                    <li key={index} className='leading-relaxed'>
                      {publication}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-500'>
                  No publications information available.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LecturerDetail
